import "core-js/features/array/find";
import "core-js/features/promise";

import "focus-visible";
import "lazysizes";
import InView from "in-view";
import Stickyfill from "stickyfilljs";
import smoothscroll from "smoothscroll-polyfill";
import "array-from-polyfill";

import HeaderGeneric from "./components/header/headerGeneric.js";
import HeaderSmall from "./components/header/headerSmall.js";
import HeaderLarge from "./components/header/headerLarge.js";
import Tabs from "./components/tabs/tabs.js";
import Accordion from "./components/accordion/accordion.js";
import Rte from "./components/rte/rte.js";
import ServiceBanner from "./components/ServiceBanner/serviceBanner.js";
import AnchorSections from "./components/AnchorSections/anchorSections.js";
import Quicklinks from "./components/quicklinks/quicklinks.js";
import PersonList from "./components/personList/personList";
import OrganisationDiagram from "./components/organisationDiagram/organisationDiagram.js";
import Carousel from "./components/carousel/carousel.js";
import Search from "./components/search/search.js";
import StyleSelect from "./components/styleselect/styleselect.js";
import PressReleases from "./components/pressReleases/pressReleases.js";
import NewsAndEvents from "./components/newsAndEvents/newsAndEvents.js";
import CTAPopup from "./components/ctaPopup/ctaPopup.js";
import UnsupportedBrowserPopup from "./components/unsupportedBrowserPopup/unsupportedBrowserPopup.js";
import CarouselWithThumbnails from "./components/carouselWithThumbnails/carouselWithThumbnails.js";
import Video from "./components/video/video.js";
import ToolLine from "./components/toolline/toolline.js";

import Contact from "./components/contact/contact.vue";
import KultunautEventFeed from "./components/kultunautEventFeed/kultunautEventFeed.vue";
import KultunautEventFeedItem from "./components/kultunautEventFeed/kultunautEventFeedItem.vue";
import HybridList from "./components/lists/hybridlist/hybridlist.vue";
import CmsList from "./components/lists/cmsList/cmsList.vue";
import FacettedList from "./components/lists/facettedList/facettedList.vue";
import HearingList from "./components/lists/hearingList/hearingList.vue";
import ProgramPageInfo from "./components/programPageInfo/programPageInfo.vue";
import AttachmentList from "./components/lists/attachmentList/attachmentList.vue";
import HotspotList from "./components/hotspotList/hotspotList.vue";
import OpeningHours from "./components/openingHours/openingHours.vue";

if (process.env.NODE_ENV !== "production") {
	console.log("Looks like we are in development mode!");
}

document.addEventListener("DOMContentLoaded", function() {
	document.querySelectorAll(".custom-select").forEach(select => {
		StyleSelect.init(select);
	});
	new InView(".inview-watch")
		.on("enter", el => {
			el.classList.add("inview--visible");
			el.classList.add("inview--was-visible");
		})
		.on("exit", el => {
			el.classList.remove("inview--visible");
		});

	new InView(".inview-watch-delayed")
		.on("enter", el => {
			el.classList.add("inview--visible");
			el.classList.add("inview-delayed--was-visible");
		})
		.on("exit", el => {
			el.classList.remove("inview--visible");
		});

	//adds sticky support in ie11
	var elements = document.querySelectorAll(".sticky");
	Stickyfill.add(elements);

	// Adds polyfill for scroll-behavoiur smooth in ie11
	smoothscroll.polyfill();
	utilities.focusWhitin();

	utilities.initComponent(HeaderGeneric, {
		el: document.querySelectorAll("body")
	});
	utilities.initComponent(HeaderSmall, {
		el: document.querySelectorAll(".header__small")
	});
	utilities.initComponent(HeaderLarge, {
		el: document.querySelectorAll(".header__large")
	});
	utilities.initComponent(ServiceBanner, {
		el: document.querySelectorAll(".service-banner")
	});
	utilities.initComponent(Tabs, {
		el: document.querySelectorAll(".tabs")
	});
	utilities.initComponent(Accordion, {
		el: document.querySelectorAll(".accordion")
	});
	utilities.initComponent(Rte, {
		el: document.querySelectorAll(".rte")
	});
	utilities.initComponent(AnchorSections, {
		el: document.querySelectorAll(".anchor-sections")
	});
	utilities.initComponent(Quicklinks, {
		el: document.querySelectorAll(".quicklinks")
	});
	utilities.initComponent(Carousel, {
		el: document.querySelectorAll(".carousel")
	});
	utilities.initComponent(OrganisationDiagram, {
		el: document.querySelectorAll(".organisationDiagram")
	});
	utilities.initComponent(CTAPopup, {
		el: document.querySelectorAll(".cta--popup")
	});
	utilities.initComponent(Video, {
		el: document.querySelectorAll(".video")
	});
	utilities.initComponent(PersonList, {
		el: document.querySelectorAll(".personList")
	});
	utilities.initComponent(Search, {
		el: document.querySelectorAll("body")
	});
	utilities.initComponent(PressReleases, {
		el: document.querySelectorAll(".press-releases")
	});
	utilities.initComponent(UnsupportedBrowserPopup, {
		el: document.querySelectorAll(".unsupported-browser-popup")
	});
	utilities.initComponent(CarouselWithThumbnails, {
		el: document.querySelectorAll(".carouselWithThumbnails")
	});
	utilities.initComponent(ToolLine, {
		el: document.querySelectorAll(".js-toolline")
	});
	// Initialize news and events only iulturnaut events
	if (document.querySelectorAll(".kultunautEventFeed").length <= 0) {
		utilities.initComponent(NewsAndEvents, {
			el: document.querySelectorAll(".news-and-events")
		});
	}
	utilities.initVueApp(HybridList, {
		el: document.querySelectorAll(".hybridlist")
	});
	utilities.initVueApp(AttachmentList, {
		el: document.querySelectorAll(".attachmentlist")
	});
	utilities.initVueApp(CmsList, {
		el: document.querySelectorAll(".cmslist")
	});
	utilities.initVueApp(FacettedList, {
		el: document.querySelectorAll(".js-facetted-list")
	});
	utilities.initVueApp(HearingList, {
		el: document.querySelectorAll(".hearinglist")
	});
	utilities.initVueApp(KultunautEventFeed, {
		el: document.querySelectorAll(".kultunautEventFeed")
	});
	utilities.initVueApp(KultunautEventFeedItem, {
		el: document.querySelectorAll(".kultunautEventFeedItem")
	});
	utilities.initVueApp(Contact, {
		el: document.querySelectorAll(".contact")
	});
	utilities.initVueApp(OpeningHours, {
		el: document.querySelectorAll(".openingHours")
	});
	utilities.initVueApp(ProgramPageInfo, {
		el: document.querySelectorAll(".program-page_info")
	});
	utilities.initVueApp(HotspotList, {
		el: document.querySelectorAll(".js-hotspot-list")
	});
});
// adds simple background-image --> background-size:cover instead of object-fit:cover on ie11
document.addEventListener("lazyloaded", function(e) {
	const el = e.target;
	const compStyles = window.getComputedStyle(el);
	const isCover = compStyles.getPropertyValue("background-size") == "cover";
	if (!utilities.supportsObjectfit && isCover) {
		utilities.objectFitToParentBackground(el);
	}
	utilities.emitter.emit("image/loaded", el);
});

// init event when kulturnaut vue app emits event
utilities.emitter.on("kulturnautLoaded", function() {
	utilities.initComponent(NewsAndEvents, {
		el: document.querySelectorAll(".news-and-events")
	});
});
